/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Slider from 'react-rangeslider'
import "./ColorPicker.css"
import Helper from "../../Utils";
import {Button, TextField, Typography} from "@material-ui/core";

const styles = theme => ({
    colorPicker: {
        width: theme.spacing.unit * 35,
    },
    colorIndicator: {
        height: theme.spacing.unit * 15,
        color: "white",
        textAlign: "center",
        lineHeight: theme.spacing.unit * 15 + "px",
    },
    colorChooserBody: {
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
    },
    slider: {
        paddingTop: theme.spacing.unit,
    },
    textField: {
        width: "30%",
        paddingLeft: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        boxSizing: "border-box"
    },
    lowerButtonContainer: {
        textAlign: "right",
        padding: theme.spacing.unit
    }
});

class ColorPicker extends React.Component {

    constructor(props) {
        super(props);
        let rgb;
        if(this.props.color.startsWith("#") || this.props.color == null)
            rgb = Helper.hex_to_RGB(this.props.color != null ? this.props.color : "#000000");
        else if(this.props.color.startsWith("rgb"))
            rgb = Helper.rgb_to_RGB(this.props.color);
        this.state = {
            colorRed: rgb.r,
            colorGreen: rgb.g,
            colorBlue: rgb.b,
        };
    }

    render() {
        const {classes} = this.props;

        return <div className={classes.colorPicker}>
            <Typography className={classes.colorIndicator} fullWidth align="center" variant="title" style={{
                backgroundColor: Helper.rgbToHex(this.state.colorRed, this.state.colorGreen, this.state.colorBlue)
            }}>
                {Helper.rgbToHex(this.state.colorRed, this.state.colorGreen, this.state.colorBlue)}
            </Typography>
            <div className={classes.colorChooserBody}>
                <div className={"sliderRed " + classes.slider}>
                    <Slider min={0}
                            max={255}
                            step={1}
                            handleLabel=""
                            orientation="horizontal"
                            value={this.state.colorRed}
                            onChange={this.onChange('colorRed')}/>
                </div>

                <div className={"sliderGreen " + classes.slider}>
                    <Slider min={0}
                            max={255}
                            step={1}
                            handleLabel=""
                            orientation="horizontal"
                            value={this.state.colorGreen}
                            onChange={this.onChange('colorGreen')}/>
                </div>
                <div className={"sliderBlue " + classes.slider}>
                    <Slider min={0}
                            max={255}
                            step={1}
                            handleLabel=""
                            orientation="horizontal"
                            value={this.state.colorBlue}
                            onChange={this.onChange('colorBlue')}/>
                </div>
                <div style={{textAlign: "center"}}>
                    <TextField
                        label="Rot"
                        value={this.state.colorRed}
                        onChange={this.onChangeByEvent('colorRed')}
                        type="number"
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        margin="normal"
                    />
                    <TextField
                        id="rgbValueGreen"
                        label="Grün"
                        value={this.state.colorGreen}
                        onChange={this.onChangeByEvent('colorGreen')}
                        type="number"
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        margin="normal"
                    />
                    <TextField
                        id="rgbValueBlue"
                        label="Blau"
                        value={this.state.colorBlue}
                        onChange={this.onChangeByEvent('colorBlue')}
                        type="number"
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        margin="normal"
                    />
                </div>
            </div>
            <div className={classes.lowerButtonContainer}>
                <Button color="secondary" onClick={this.props.onClose}>Abbrechen</Button>
                <Button color="secondary" onClick={this.callOnChangeCallback}>OK</Button>
            </div>
        </div>
    }

    onChange = key => value => this.setState({[key]: value});
    onChangeByEvent = key => event => this.setState({[key]: event.target.value});
    callOnChangeCallback = () => this.props.onChange(Helper.rgbToHex(this.state.colorRed, this.state.colorGreen, this.state.colorBlue));
}

ColorPicker.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ColorPicker);